import React from 'react';
import PageHeader from '../components/layout/PageHeader';
import Button from '../components/ui/Button';
import { BuildingIcon, UsersIcon, AwardIcon, HeartIcon, CheckIcon } from 'lucide-react';
const CorporatePartnerships = () => {
  return <div className="min-h-screen bg-white" data-id="element-3041">
      <PageHeader title="Corporate Partnerships" description="Partner with Isonyin Grammar School to make a lasting impact on education while achieving your corporate social responsibility goals." backgroundImage="https://images.unsplash.com/photo-1556761175-5973dc0f32e7?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1932&q=80" breadcrumbs={[{
      label: 'Home',
      path: '/'
    }, {
      label: 'Support',
      path: '/support'
    }, {
      label: 'Corporate Partnerships',
      path: '/support/corporate-partnerships'
    }]} data-id="element-3042" />
      <div className="container mx-auto px-4 py-12" data-id="element-3043">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 mb-16" data-id="element-3044">
          <div data-id="element-3045">
            <h2 className="text-3xl font-bold text-blue-900 mb-6" data-id="element-3046">
              Why Partner With Us?
            </h2>
            <p className="text-gray-700 mb-8" data-id="element-3047">
              A partnership with Isonyin Grammar School offers your organization
              the opportunity to make a meaningful contribution to education
              while enhancing your brand's reputation and fulfilling your
              corporate social responsibility objectives.
            </p>
            <div className="space-y-6" data-id="element-3048">
              <div className="flex items-start" data-id="element-3049">
                <div className="p-2 bg-blue-100 rounded-full mr-3" data-id="element-3050">
                  <HeartIcon className="h-6 w-6 text-blue-700" data-id="element-3051" />
                </div>
                <div data-id="element-3052">
                  <h3 className="font-bold text-blue-900 mb-2" data-id="element-3053">
                    Community Impact
                  </h3>
                  <p className="text-gray-700" data-id="element-3054">
                    Make a tangible difference in the local community by
                    investing in the education of future leaders.
                  </p>
                </div>
              </div>
              <div className="flex items-start" data-id="element-3055">
                <div className="p-2 bg-blue-100 rounded-full mr-3" data-id="element-3056">
                  <BuildingIcon className="h-6 w-6 text-blue-700" data-id="element-3057" />
                </div>
                <div data-id="element-3058">
                  <h3 className="font-bold text-blue-900 mb-2" data-id="element-3059">
                    Brand Association
                  </h3>
                  <p className="text-gray-700" data-id="element-3060">
                    Associate your brand with a respected educational
                    institution with over 50 years of excellence.
                  </p>
                </div>
              </div>
              <div className="flex items-start" data-id="element-3061">
                <div className="p-2 bg-blue-100 rounded-full mr-3" data-id="element-3062">
                  <UsersIcon className="h-6 w-6 text-blue-700" data-id="element-3063" />
                </div>
                <div data-id="element-3064">
                  <h3 className="font-bold text-blue-900 mb-2" data-id="element-3065">
                    Employee Engagement
                  </h3>
                  <p className="text-gray-700" data-id="element-3066">
                    Create meaningful volunteer opportunities for your employees
                    to contribute their skills and time.
                  </p>
                </div>
              </div>
              <div className="flex items-start" data-id="element-3067">
                <div className="p-2 bg-blue-100 rounded-full mr-3" data-id="element-3068">
                  <AwardIcon className="h-6 w-6 text-blue-700" data-id="element-3069" />
                </div>
                <div data-id="element-3070">
                  <h3 className="font-bold text-blue-900 mb-2" data-id="element-3071">Recognition</h3>
                  <p className="text-gray-700" data-id="element-3072">
                    Receive recognition and visibility through our various
                    communication channels and events.
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="bg-blue-50 p-8 rounded-lg" data-id="element-3073">
            <h2 className="text-3xl font-bold text-blue-900 mb-6" data-id="element-3074">
              Partnership Opportunities
            </h2>
            <div className="space-y-6" data-id="element-3075">
              <div className="bg-white p-6 rounded-lg shadow-sm" data-id="element-3076">
                <h3 className="font-bold text-blue-900 mb-2" data-id="element-3077">
                  Infrastructure Development
                </h3>
                <p className="text-gray-700 mb-4" data-id="element-3078">
                  Support the construction or renovation of school facilities
                  with naming rights and recognition.
                </p>
                <ul className="space-y-2" data-id="element-3079">
                  <li className="flex items-center" data-id="element-3080">
                    <CheckIcon className="h-5 w-5 text-green-500 mr-2" data-id="element-3081" />
                    <span className="text-gray-700" data-id="element-3082">Science laboratories</span>
                  </li>
                  <li className="flex items-center" data-id="element-3083">
                    <CheckIcon className="h-5 w-5 text-green-500 mr-2" data-id="element-3084" />
                    <span className="text-gray-700" data-id="element-3085">
                      Library and study areas
                    </span>
                  </li>
                  <li className="flex items-center" data-id="element-3086">
                    <CheckIcon className="h-5 w-5 text-green-500 mr-2" data-id="element-3087" />
                    <span className="text-gray-700" data-id="element-3088">Sports facilities</span>
                  </li>
                </ul>
              </div>
              <div className="bg-white p-6 rounded-lg shadow-sm" data-id="element-3089">
                <h3 className="font-bold text-blue-900 mb-2" data-id="element-3090">
                  Academic Programs
                </h3>
                <p className="text-gray-700 mb-4" data-id="element-3091">
                  Invest in educational programs and initiatives that enhance
                  learning outcomes.
                </p>
                <ul className="space-y-2" data-id="element-3092">
                  <li className="flex items-center" data-id="element-3093">
                    <CheckIcon className="h-5 w-5 text-green-500 mr-2" data-id="element-3094" />
                    <span className="text-gray-700" data-id="element-3095">
                      STEM education programs
                    </span>
                  </li>
                  <li className="flex items-center" data-id="element-3096">
                    <CheckIcon className="h-5 w-5 text-green-500 mr-2" data-id="element-3097" />
                    <span className="text-gray-700" data-id="element-3098">
                      Digital literacy initiatives
                    </span>
                  </li>
                  <li className="flex items-center" data-id="element-3099">
                    <CheckIcon className="h-5 w-5 text-green-500 mr-2" data-id="element-3100" />
                    <span className="text-gray-700" data-id="element-3101">
                      Teacher training and development
                    </span>
                  </li>
                </ul>
              </div>
              <div className="bg-white p-6 rounded-lg shadow-sm" data-id="element-3102">
                <h3 className="font-bold text-blue-900 mb-2" data-id="element-3103">
                  Student Support
                </h3>
                <p className="text-gray-700 mb-4" data-id="element-3104">
                  Help create opportunities for talented students from all
                  backgrounds.
                </p>
                <ul className="space-y-2" data-id="element-3105">
                  <li className="flex items-center" data-id="element-3106">
                    <CheckIcon className="h-5 w-5 text-green-500 mr-2" data-id="element-3107" />
                    <span className="text-gray-700" data-id="element-3108">Scholarship programs</span>
                  </li>
                  <li className="flex items-center" data-id="element-3109">
                    <CheckIcon className="h-5 w-5 text-green-500 mr-2" data-id="element-3110" />
                    <span className="text-gray-700" data-id="element-3111">
                      Mentorship initiatives
                    </span>
                  </li>
                  <li className="flex items-center" data-id="element-3112">
                    <CheckIcon className="h-5 w-5 text-green-500 mr-2" data-id="element-3113" />
                    <span className="text-gray-700" data-id="element-3114">
                      Career development support
                    </span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div className="bg-blue-900 text-white p-8 rounded-lg mb-16" data-id="element-3115">
          <div className="text-center mb-8" data-id="element-3116">
            <h2 className="text-3xl font-bold mb-4" data-id="element-3117">Partner Benefits</h2>
            <p className="max-w-2xl mx-auto" data-id="element-3118">
              Our corporate partners receive comprehensive benefits and
              recognition for their support.
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-3119">
            <div className="bg-blue-800/50 p-6 rounded-lg" data-id="element-3120">
              <h3 className="font-bold text-xl mb-4" data-id="element-3121">Brand Visibility</h3>
              <ul className="space-y-3" data-id="element-3122">
                <li className="flex items-center" data-id="element-3123">
                  <CheckIcon className="h-5 w-5 text-yellow-400 mr-2" data-id="element-3124" />
                  <span data-id="element-3125">Logo placement on school website</span>
                </li>
                <li className="flex items-center" data-id="element-3126">
                  <CheckIcon className="h-5 w-5 text-yellow-400 mr-2" data-id="element-3127" />
                  <span data-id="element-3128">Recognition in publications</span>
                </li>
                <li className="flex items-center" data-id="element-3129">
                  <CheckIcon className="h-5 w-5 text-yellow-400 mr-2" data-id="element-3130" />
                  <span data-id="element-3131">Event sponsorship opportunities</span>
                </li>
              </ul>
            </div>
            <div className="bg-blue-800/50 p-6 rounded-lg" data-id="element-3132">
              <h3 className="font-bold text-xl mb-4" data-id="element-3133">Employee Engagement</h3>
              <ul className="space-y-3" data-id="element-3134">
                <li className="flex items-center" data-id="element-3135">
                  <CheckIcon className="h-5 w-5 text-yellow-400 mr-2" data-id="element-3136" />
                  <span data-id="element-3137">Volunteer opportunities</span>
                </li>
                <li className="flex items-center" data-id="element-3138">
                  <CheckIcon className="h-5 w-5 text-yellow-400 mr-2" data-id="element-3139" />
                  <span data-id="element-3140">Mentorship programs</span>
                </li>
                <li className="flex items-center" data-id="element-3141">
                  <CheckIcon className="h-5 w-5 text-yellow-400 mr-2" data-id="element-3142" />
                  <span data-id="element-3143">Speaking engagements</span>
                </li>
              </ul>
            </div>
            <div className="bg-blue-800/50 p-6 rounded-lg" data-id="element-3144">
              <h3 className="font-bold text-xl mb-4" data-id="element-3145">Impact Reporting</h3>
              <ul className="space-y-3" data-id="element-3146">
                <li className="flex items-center" data-id="element-3147">
                  <CheckIcon className="h-5 w-5 text-yellow-400 mr-2" data-id="element-3148" />
                  <span data-id="element-3149">Regular progress updates</span>
                </li>
                <li className="flex items-center" data-id="element-3150">
                  <CheckIcon className="h-5 w-5 text-yellow-400 mr-2" data-id="element-3151" />
                  <span data-id="element-3152">Impact assessment reports</span>
                </li>
                <li className="flex items-center" data-id="element-3153">
                  <CheckIcon className="h-5 w-5 text-yellow-400 mr-2" data-id="element-3154" />
                  <span data-id="element-3155">Media coverage highlights</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div className="max-w-4xl mx-auto" data-id="element-3156">
          <div className="text-center mb-8" data-id="element-3157">
            <h2 className="text-3xl font-bold text-blue-900 mb-4" data-id="element-3158">
              Become a Partner
            </h2>
            <p className="text-gray-700" data-id="element-3159">
              Ready to make a difference? Fill out the form below to start a
              conversation about partnership opportunities.
            </p>
          </div>
          <form className="bg-white p-8 rounded-lg shadow-md" data-id="element-3160">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6" data-id="element-3161">
              <div data-id="element-3162">
                <label className="block text-gray-700 font-medium mb-2" data-id="element-3163">
                  Company Name
                </label>
                <input type="text" className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500" required data-id="element-3164" />
              </div>
              <div data-id="element-3165">
                <label className="block text-gray-700 font-medium mb-2" data-id="element-3166">
                  Industry
                </label>
                <input type="text" className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500" required data-id="element-3167" />
              </div>
              <div data-id="element-3168">
                <label className="block text-gray-700 font-medium mb-2" data-id="element-3169">
                  Contact Person
                </label>
                <input type="text" className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500" required data-id="element-3170" />
              </div>
              <div data-id="element-3171">
                <label className="block text-gray-700 font-medium mb-2" data-id="element-3172">
                  Position/Title
                </label>
                <input type="text" className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500" required data-id="element-3173" />
              </div>
              <div data-id="element-3174">
                <label className="block text-gray-700 font-medium mb-2" data-id="element-3175">
                  Email
                </label>
                <input type="email" className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500" required data-id="element-3176" />
              </div>
              <div data-id="element-3177">
                <label className="block text-gray-700 font-medium mb-2" data-id="element-3178">
                  Phone
                </label>
                <input type="tel" className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500" required data-id="element-3179" />
              </div>
            </div>
            <div className="mb-6" data-id="element-3180">
              <label className="block text-gray-700 font-medium mb-2" data-id="element-3181">
                Areas of Interest
              </label>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-3182">
                <label className="flex items-center" data-id="element-3183">
                  <input type="checkbox" className="mr-2" data-id="element-3184" />
                  <span data-id="element-3185">Infrastructure Development</span>
                </label>
                <label className="flex items-center" data-id="element-3186">
                  <input type="checkbox" className="mr-2" data-id="element-3187" />
                  <span data-id="element-3188">Academic Programs</span>
                </label>
                <label className="flex items-center" data-id="element-3189">
                  <input type="checkbox" className="mr-2" data-id="element-3190" />
                  <span data-id="element-3191">Student Support</span>
                </label>
                <label className="flex items-center" data-id="element-3192">
                  <input type="checkbox" className="mr-2" data-id="element-3193" />
                  <span data-id="element-3194">Other</span>
                </label>
              </div>
            </div>
            <div className="mb-6" data-id="element-3195">
              <label className="block text-gray-700 font-medium mb-2" data-id="element-3196">
                Message
              </label>
              <textarea rows={4} className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500" placeholder="Tell us about your partnership interests and goals..." required data-id="element-3197"></textarea>
            </div>
            <Button type="submit" variant="primary" className="w-full" data-id="element-3198">
              Submit Partnership Inquiry
            </Button>
          </form>
        </div>
      </div>
    </div>;
};
export default CorporatePartnerships;